import React from 'react'
import { gql, useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import DeleteOutlinedIcon from 'components/material-symbol/icons/Delete'
import Dialog from 'components/dialog'
import { GET_LESSON_TYPES_AND_COACH_FACILITIES } from './queries'

const DELETE_LESSON_TYPE = gql`
  mutation DeleteLessonType($id: ID!) {
    deleteLessonType(id: $id) {
      success
      message
    }
  }
`

const DeleteBookingTypeDialog = ({
  bookingTypeId,
  isOpen,
  onClose,
  onDeleted,
}) => {
  const { enqueueSnackbar } = useSnackbar()

  const [deleteLessonType, { loading }] = useMutation(DELETE_LESSON_TYPE, {
    refetchQueries: [{ query: GET_LESSON_TYPES_AND_COACH_FACILITIES }],
    onCompleted: data => {
      if (data.deleteLessonType.success) {
        enqueueSnackbar('Booking Type has been successfully deleted.', {
          variant: 'success',
        })
        onDeleted?.()
        onClose?.()
      } else {
        enqueueSnackbar(data.deleteLessonType.message, { variant: 'error' })
      }
    },
    onError: error => {
      window.rg4js &&
        window.rg4js('send', {
          error: error,
          tags: ['booking-types'],
        })
      enqueueSnackbar('An error has occurred. Please try again later.', {
        variant: 'error',
      })
    },
  })

  const handleDelete = () => {
    deleteLessonType({
      variables: {
        id: bookingTypeId,
      },
    })
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} maxWidth="xs">
      {({ closeDialog }) => (
        <>
          <DialogTitle>Delete Booking Type</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              Lessons that have already been created will not be impacted.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={closeDialog}>
              Cancel
            </Button>
            <Button
              data-cy="confirmDelete"
              color="primary"
              variant="contained"
              onClick={handleDelete}
              disabled={loading}
              startIcon={<DeleteOutlinedIcon />}
            >
              Delete
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default DeleteBookingTypeDialog
